import { CurrencyEnum } from './plan.interface';

export enum OrderStatusEnum {
  AWAITING_SHIPMENT = 'awaiting_shipment',
  AWAITING_PAYMENT = 'awaiting_payment',
  SHIPPED = 'shipped',
  ON_HOLD = 'on_hold',
  CANCELLED = 'cancelled'
}

// Canonical fulfillment lifecycle (server OrderFulfillmentStatus). Served on every admin order
// row / diagnostics payload — the client renders it, never re-derives it from legacy fields.
export enum OrderFulfillmentStatusEnum {
  NOT_APPLICABLE = 'not_applicable',
  AWAITING_AUTHORIZATION = 'awaiting_authorization',
  NEEDS_ADDRESS = 'needs_address',
  PREPARING_ASSETS = 'preparing_assets',
  READY_TO_DISPATCH = 'ready_to_dispatch',
  DISPATCHED = 'dispatched',
  IN_PRODUCTION = 'in_production',
  SHIPPED = 'shipped',
  ERROR = 'error',
  CANCELED = 'canceled'
}

// What an admin should do about an order right now (server deriveActionNeeded).
export type FulfillmentActionNeeded = 'none' | 'fix_address' | 'investigate' | 'dispatch' | 'stuck';

export enum OrderTypeEnum {
  SUBSCRIPTION_PURCHASE = 'subscription',
  BOOK_PURCHASE = 'book',
  CREDITS_PURCHASE = 'image_credits',
  PRE_ORDER_BOOK = 'pre_order_book',
  BULK_PRINT = 'bulk_print'
}

export interface OrderExtraInfoModel {
  plan?: string;
  credits?: number;
  unlimitedDownloads?: 'Yes' | 'No' | string;
  additionImageCreditsInfo?: string;
  bookName?: string; // set on book orders
  [key: string]: any;
}

export interface OrderDetailsModel {
  orderNumber: string;
  bookId: string;
  bookName: string;
  quantity: number | null;
  price: string;
  billingAddress1: string;
  billingAddress2?: string;
  billingCardHolderName: string;
  billingCity: string;
  billingPostalCode: string;
  billingState?: string;
  shippingAddress1: string;
  shippingAddress2?: string;
  shippingCity: string;
  shippingEmail: string;
  shippingState: string;
  shippingZip: string;
  shippingCountry?: string;
  shipstationOrderId?: string;
  luluPrintJobId?: string;
  lastFulfillmentError?: string;
  shipstationSyncFailedAt?: any;
  extraInfo?: OrderExtraInfoModel;
  totalBooksInBulk?: number;
  bulkPrintOrderNumbers?: number[];
  parentBulkPrintOrderNumber?: string;
  classroomId?: string;
  classroomName?: string;
  // Combined classroom shipment: the ShipStation order lives under the release parent's number.
  shipmentOrderNumber?: number;
  shipmentSize?: number;
  printProcessingState?: string;
  printProcessingError?: string;
  waitToShip?: boolean;
  fulfillmentStatus?: OrderFulfillmentStatusEnum;
  fulfillmentActionNeeded?: FulfillmentActionNeeded;
  printBatchId?: string;
  printBatchNumber?: number;
  trackingNumber?: string;
  carrier?: string;
  shippedAt?: any;
  status: OrderStatusEnum;
  timestamp: number;
  orderType: string;
  additionalPageCost: number;
  shippingAmount?: number;
  coupon?: string;
  couponDiscount?: string;
  
  // Currency information
  currency?: CurrencyEnum;
  currencySymbol?: string;

  [key: string]: any;
}